//import node_modules
import React, { FunctionComponent } from "react";
import { formatDistanceToNowStrict } from "date-fns/formatDistanceToNowStrict";
import { format } from "date-fns/format";

//types
import type { ReadTimeResults } from "reading-time";

type PublishedProps = {
  published_time: number;
  read_time?: ReadTimeResults;
};

const PublishedComponent: FunctionComponent<PublishedProps> = ({ published_time, read_time }) => {
  if (!read_time) return null;

  return (
    <div>
      <span>Published </span>
      <span>
        {format(published_time, "PPP")} ({formatDistanceToNowStrict(published_time, { addSuffix: true })})
      </span>
      <span> • </span>
      <span>{read_time.text}</span>
    </div>
  );
};

export default React.memo(PublishedComponent);
